<router-outlet />

<bootstrap-modal></bootstrap-modal>

<ng-container *ngFor="let tooltip of tooltipService.tooltipsList">
    <bg-tooltip
        [ref]="tooltip.ref"
        [title]="tooltip.title"
        [position]="tooltip.position"
        [color]="tooltip.color"
        [width]="tooltip.width"
        [tooltipType]="tooltip.tooltipType"
        [tooltipHeaderTitle]="tooltip.tooltipHeaderTitle">
    </bg-tooltip>
</ng-container>
